module.exports = __webpack_public_path__ + "static/img/Myles-Martin.0500406.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Myles-Martin.jpg
// module id = B6jr
// module chunks = 0